import { FC } from 'react';
import { useDeleteData } from './delete.hook';

/**
 * Delete component
 * @description Content for the PortfoliosSettings flow Delete stage.
 * @link https://www.figma.com/file/16ideRW6XB1s57uA93ppSl/Manager--%7C-File-for-development?type=design&node-id=2305-153868&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const Delete: FC = () => {
  const { stages, currentStage } = useDeleteData();

  return stages && currentStage ? stages[currentStage] : null;
};

export { Delete };
